module.exports = __webpack_public_path__ + "static/media/chat.959c5c35.svg";